// redux/features/search/searchSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

export interface SearchFilters {
  order_by: string;
  category?: string;
  min_price?: number;
  max_price?: number;
  search?: string;
  page?: number;
  per_page?: number;
  skin_type?: string[];
}

interface PaginationMeta {
  current_page: number;
  from?: number; // Made optional
  last_page: number;
  links?: Array<{ url: string | null; label: string; active: boolean }>; // Made optional
  path?: string; // Made optional
  per_page: number;
  to?: number; // Made optional
  total: number;
}

interface SearchState {
  results: any[];
  filters: SearchFilters;
  loading: boolean;
  meta: PaginationMeta;
}

const initialMeta: PaginationMeta = {
  current_page: 1,
  from: 1,
  last_page: 1,
  links: [],
  path: '',
  per_page: 24,
  to: 1,
  total: 0,
};

const initialState: SearchState = {
  results: [],
  filters: {
    page: 1,
    order_by: 'default',
    per_page: 24,
  },
  loading: false,
  meta: initialMeta,
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<SearchFilters>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setResults: (
      state,
      action: PayloadAction<{ results: any[]; meta: PaginationMeta }>
    ) => {
      state.results = action.payload.results;
      state.meta = action.payload.meta;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setFilters, setResults, setLoading } = searchSlice.actions;

export const selectSearchResults = (state: RootState) => state.search.results;
export const selectSearchMeta = (state: RootState) => state.search.meta;
export const selectSearchFilters = (state: RootState) => state.search.filters;
export const selectSearchLoading = (state: RootState) => state.search.loading;

export default searchSlice.reducer;
